<template>
    <div class="tab-pane fade" id="returns">
        <h3>Danh sách trả hàng</h3>
        <div class="table-responsive">
            <hpo-filter :headers="receipt_headers" :viewName="'account_returns'" v-on:applyFilter="applyFilterReturn"
                v-on:quickFilter="quickFilterReturn"></hpo-filter>
            <v-data-table :headers="receipt_headers" :items="returns" :options.sync="return_pagination"
                :server-items-length="total_return" :footer-props="items_per_page" :must-sort="true" :loading="loading"
                :mobile-breakpoint="100" class="elevation-1 free-col">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>HD{{ pad(item.id, 6) }}</td>
                        <td>{{ item.created_at | display_date }}</td>
                        <td class="text-right">{{ item.total | currency }}</td>
                        <td class="text-right">{{ item.discount | currency }}</td>
                        <td class="text-right">{{ item.amount | currency }}</td>
                        <td><a @click="openReturnDetail(item.id)">Xem</a></td>
                    </tr>
                </template>
                <template v-slot:body.append v-if="summary_return">
                    <tr class="total-summary-td">
                        <td colspan="2" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ summary_return.total | currency }}</td>
                        <td class="text-end font-weight-bold">{{ summary_return.discount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ summary_return.amount | currency }}</td>
                        <td></td>
                    </tr>
                </template>
            </v-data-table>
        </div>
        <v-dialog v-model="dialogDetailReturn" max-width="800px">
            <v-card v-if="selectedReturn">
                <v-card-title>
                <span class="title">Chi tiết trả hàng #{{ selectedReturn.id }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md pa-0>
                        <v-data-table :headers="detail_header" :items="selectedReturn.return_products" disable-pagination hide-default-footer :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td>{{ item.product_code }}</td>
                                    <td>{{ item.product_name }}</td>
                                    <td class="text-right">
                                        {{ item.qty | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.unit_price | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.discount | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.price | currency }}
                                    </td>
                                    <td class="text-right">
                                        {{ item.line_total | currency }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1 white--text" @click="dialogDetailReturn = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from '@/configs'
import Filtering from "@/components/Filtering";
import _ from 'lodash';
import { display_color } from "@/commons/formater";
import { pad } from '@/commons/utils';
export default {
    components: {
        "hpo-filter": Filtering
    },
    data () {
        return {
            viewName: "account_returns",
            pad: pad,
            display_color: display_color,
            receipt_headers: [{
                    text: "Mã đơn",
                    value: "id",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tổng tiền",
                    value: "total",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng sau giảm",
                    value: "amount",
                    filterable: true,
                    align: 'end',
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    width: "40px"
                }
            ],
            detail_header: [
                {
                    text: "Mã SP",
                    value: "product_code",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "Tên SP",
                    value: "product_name",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"],
                },
                {
                    text: "SL",
                    value: "qty",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Đơn giá",
                    value: "unit_price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Giảm giá",
                    value: "discount",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Giá bán",
                    value: "price",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                },
                {
                    text: "Thành tiền",
                    value: "line_total",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"],
                }
            ],
            return_pagination: {...configs.PAGINATION, itemsPerPage: 10},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            filterReturnConditions: [],
            quickFilterReturnConditions: [],
            selectedItem: null,
            dialogItem: false,
            dialogDetailReturn: false
        }
    },
    computed: {
        ...mapState({
            returns: state => state.returns.all.data,
            total_return: state => state.returns.all.total,
            summary_return: state => state.returns.all.summary,
            selectedReturn: state => state.returns.selected,
            loading: state => state.returns.loading
        }),
        customer_id() {
            return this.$store.state.authentication.user.id;
        },
    },
    watch: {
        return_pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterReturnConditions = !_.isEmpty(filterConditions) ? filterConditions['account_returns'] : []
                this.filter_data_return();
            },
            deep: true
        },
    },
    methods: {
        refresh_data() {
            this.filter_data_return();
        },
        filter_data_return() {
            var param = {
                pagination: this.return_pagination,
                filter: this.filterReturnConditions,
                quickFilter: this.quickFilterReturnConditions
            };
            this.$store.dispatch("returns/getList", param);
        },
        applyFilterReturn(filterConditions) {
            let sortBy = this.return_pagination.sortBy
            let sortDesc = this.return_pagination.sortDesc
            this.return_pagination = {...configs.PAGINATION, itemsPerPage: 10};
            this.return_pagination.sortBy = sortBy;
            this.return_pagination.sortDesc = sortDesc;
            this.filterReturnConditions = filterConditions;
            this.filter_data_return();
        },
        quickFilterReturn(filterConditions) {
            this.quickFilterReturnConditions = filterConditions;
            this.filter_data_return();
        },
        openReturnDetail(id) {
            this.$store.dispatch("returns/getDetail", id)
            this.dialogDetailReturn = true;
        },
    },
    mounted () {
        this.$root.$emit('COMPONENT_LOADED');
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA");
    }
}
</script>